import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'pregunta-frecuente',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Preguntas frecuentes' }] },
        loadComponent: () => import('./pages/pregunta-frecuente-lista/pregunta-frecuente-lista.component'),
      },
    ],
  },
];
